import Vue from 'vue'
import axios from 'axios'
import loader from './loader.vue'
import InfiniteLoading from 'vue-infinite-loading'


/***************** mokuji ********************/

window.onload = () =>{
  if(document.querySelector(".toc_list")){
    let object_origin = document.querySelector(".toc_list")
    let object = object_origin.cloneNode(true)
    let target = document.querySelector(".mokuji-wrap__inner")
    target.prepend(object)
    let parent = document.getElementsByClassName("mokuji-wrap")[0]
    document.getElementById("Mokuji").onclick = () =>{
      if(parent.classList.contains("mokuji-wrap__on")){
        parent.classList.remove("mokuji-wrap__on")
      }else{
        parent.classList.add("mokuji-wrap__on")
      }
    }
    document.getElementById("MokujiClose").onclick = () =>{
      if(parent.classList.contains("mokuji-wrap__on")){
        parent.classList.remove("mokuji-wrap__on")
      }else{
        parent.classList.add("mokuji-wrap__on")
      }
    }
  }
}

/*******************
  rakuten Ad
*******************/
if(document.getElementsByClassName('article-body')[0]){
  const tableOrigin = document.getElementsByClassName('article-body')[0].getElementsByTagName('table')
  const tableClone  = Array.from(tableOrigin)
  tableClone.map((x,i)=>{
    if( x.innerText.indexOf('楽天で購入') != -1 ){
      tableOrigin[i].classList.add('rakuten-table')
    }
  })
}

/*******************
  tabs
*******************/

if(document.getElementById('Tabs')){
  const TabsInstance = new Vue({
    el: "#Tabs",
    data() {
      return {
        width: 0,
        count: 0,
        num: 0,
        listWidth: [],
        innerWidth: 0,
        margin: 2, // listの横margin（セルフ）
        // scrollX: 0,
        // scrollXMax: 0 
      }
    },
    mounted(){
      this.scrollXMax = this.$el.scrollLeftMax
      this.insertWidth() // 横幅関連
      this.count = this.$el.dataset.count
      this.width = this.$el.clientWidth
      // this.$el.addEventListener('scroll', this.onScroll)
    },
    methods: {
      // onScroll(){
      //   const el = this.$el
      //   // this.scrollX = el.scrollLeft
      //   // if(el.scrollLeft > this.scrollXMax){
      //   //   el.scrollLeft = this.scrollXMax
      //   // }
      //   console.log(`Max:${el.scrollLeftMax} / scroll:${el.scrollLeft}`)
      // },
      // 動かす距離の取得
      async getWidth(){
        // num は、選択したリストのindex
        let moveWidth = 0; // 移動距離の初期化
        for (var i = 0; i <= this.num; i++) {
          if(i!=this.num){
            // 通常はmoveWidthに連続してタブの幅を足していく
            moveWidth = moveWidth + this.listWidth[i]
          }else{
            // 中央に持ってきたいので、現在のタブは半分の長さだけ足す
            moveWidth = moveWidth + ( this.listWidth[i] / 2 )
          }
        }
        return moveWidth
      },
      // innerのleft値 / tabID 変更
      async addWidth(num){

        // tabIDの送信
        this.sendTabID(num)

        this.num = num
        let result = await this.getWidth(num)
        let length = -result + (this.width/2)
        if(length > 0 ){
          document.querySelector('.tabs__inner').style.transform = 'translateX(0px)'
        }else if(length < this.width - this.innerWidth){
          document.querySelector('.tabs__inner').style.transform = 'translateX('+ -(this.innerWidth - this.width) + 'px)'
        }else{
          document.querySelector('.tabs__inner').style.transform = 'translateX(' + length + 'px)'
        }
      },
      //タブIDの送信
      sendTabID(num){
        const thisTab = document.querySelectorAll('.tab-item')[num]
        spListInstance.tabID = thisTab.dataset.id
      },
      // 各タブの横幅を配列化
      getAllListWidth(){
        let tabs = document.querySelectorAll('.tab-item')
        let listWidthArray = []
        Array.from(tabs).forEach((x)=>{
          listWidthArray.push(x.clientWidth+2)
        })
        return listWidthArray
      },
      // innerの横幅取得
      getInnerWidth(){
        let result = this.listWidth.reduce((accumulator,currentVal)=>{
          return accumulator + currentVal
        })
        return result
      },
      // 横幅関係の処理
      async insertWidth(){
        this.listWidth = await this.getAllListWidth()
        const result = await this.getInnerWidth()
        this.innerWidth = result
        document.querySelector('.tabs__inner').style.width = result + 'px'
      },
      // スクロール量の取得
      getScrollTab(){


      }
    },
  })
}


/*******************
  spList
*******************/

if (document.getElementById('spList')) {
  var spListInstance = new Vue({
    el: "#spList",
    data() {
      return {
        datas: [],
        page: 1,
        total: 0,
        getPage: 5,
        tabID: 0,
      };
    },
    components: {
      InfiniteLoading,
      loader,
      // Adsense,
      // InFeedAdsense
    },
    mounted(){
      this.getHeader() // 初期合計POST数取得
      this.getPosts() // 初期POST取得
    },
    methods:{
      getParam(string) { // カテゴリーIDのparam化
        // string は 接続辞 ? or &
        if( this.tabID != 0 ){ // 初期値もしくはNEW以外
          return string + 'categories=' + this.tabID
        }else{ // 初期値もしくはNEW
          return ''
        }
      },
      getHeader(){ // POST合計取得
        axios.get(BASEURL + '/posts' + this.getParam('?'))
        .then((res) => {
          this.total = res['headers']['x-wp-totalpages']
        })
      },
      getPosts(){ // 投稿取得
        axios.get(BASEURL + '/posts?_embed&page='+this.page + this.getParam('&'))
        .then( (res) => {
          res.data.map((x)=>{
            this.datas.push(x)
          })
        })
      },
      infiniteHandler($state) { // infiniteloading
        setTimeout(() => {
          if( this.page < this.getPage ){
            this.page = this.page + 1
            this.getPosts()
            $state.loaded()
          }
        }, 1000)
      },
      getImgUrl(data,imagesize){ // サムネイル取得
        if(data._embedded && 
           data._embedded['wp:featuredmedia'] &&
           data._embedded['wp:featuredmedia'][0].media_details &&
           data._embedded['wp:featuredmedia'][0].media_details.sizes[imagesize]){
          return data._embedded['wp:featuredmedia'][0].media_details.sizes[imagesize].source_url
        }else{
          return false
        }
      },
      postDate(data,flag = false) {
        const dateArray = data.date.split('-')
        const y = dateArray[0]
        const m = dateArray[1]
        const d = dateArray[2].split("T")[0]
        return flag ? y+m+d : y+'年'+m+'月'+d+'日'
      },
    },
    watch: {
      tabID() {
        // 初期化
        this.datas =  []
        this.page = 1
        this.total = 0

        this.getHeader()
        this.getPosts()
      }
    }
  })
}

